import { render, staticRenderFns } from "./ButtonTemplate.vue?vue&type=template&id=4d771a6a&scoped=true&"
import script from "./ButtonTemplate.vue?vue&type=script&lang=js&"
export * from "./ButtonTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTemplate.vue?vue&type=style&index=0&id=4d771a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d771a6a",
  null
  
)

export default component.exports